type ModelRefType = {
  model: string;
  collection: string;
  discriminators?: Record<string, string>;
  discriminatorKey?: string;
};

/**
 * Database references for models
 */
export const dbRef = {
  admin: {
    model: "Admin",
    collection: "admins",
  },
  cart: {
    model: "Cart",
    collection: "carts",
  },
  category: {
    model: "Category",
    collection: "categories",
  },
  dispute: {
    model: "Dispute",
    collection: "disputes",
  },
  expoPushToken: {
    model: "ExpoPushToken",
    collection: "expo-push-tokens",
  },
  expoPushTicket: {
    model: "ExpoPushTicket",
    collection: "expo-push-tickets",
  },
  note: {
    model: "Note",
    collection: "notes",
  },
  order: {
    model: "Order",
    collection: "orders",
  },
  payoutRequest: {
    model: "PayoutRequest",
    collection: "PayoutRequests",
  },
  profile: {
    model: "Profile",
    collection: "profiles",
    discriminatorKey: "profileType",
    /** @satisfies ProfileTypesEnum */
    discriminators: {
      client: "ClientProfile",
      company: "CompanyProfile",
      professional: "ProfessionalProfile",
      business: "BusinessProfile",
    },
  },
  review: {
    model: "Review",
    collection: "reviews",
  },
  role: {
    model: "Role",
    collection: "roles",
  },
  serviceProject: {
    model: "ServiceProject",
    collection: "serviceprojects",
  },
  serviceCharges: {
    model: "serviceCharge",
    collection: "servicecharges",
  },
  service: {
    model: "Service",
    collection: "services",
  },
  task: {
    model: "Task",
    collection: "tasks",
  },
  transaction: {
    model: "Transaction",
    collection: "transactions",
  },
  user: {
    model: "User",
    collection: "users",
  },
  wallet: {
    model: "Wallet",
    collection: "wallets",
  },
} satisfies Record<string, ModelRefType>;
